import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './QualificationsViewer.css';
import CheckBox from 'components/shared/checkbox/CheckBox';
import Dropdown from 'components/shared/dropdown/Dropdown';
import { QualificationTypeEnum } from 'domain/qualification-type-enum';

class QualificationsViewer extends Component {
  static propTypes = {
    qualifications: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            selected: PropTypes.bool,
          })
        ),
        selected: PropTypes.bool,
        trade: PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string,
        }),
        type: PropTypes.instanceOf(QualificationTypeEnum).isRequired,
      })
    ),
    readOnly: PropTypes.bool,
    onOptionSelected: PropTypes.func,
    onQualificationSelected: PropTypes.func,
  };

  static defaultProps = {
    qualifications: [],
    readOnly: false,
  };

  render() {
    const generalSection = [];
    const otherSection = [];
    let tradeSection = null; // trade: string, { label: string, lines: [] }

    this.props.qualifications.forEach((qualification) => {
      switch (qualification.type) {
        case QualificationTypeEnum.GENERAL:
          if (
            !this.props.readOnly ||
            (this.props.readOnly && qualification.selected)
          ) {
            generalSection.push(this.createLine(qualification));
          }
          break;

        case QualificationTypeEnum.OTHER:
          if (
            !this.props.readOnly ||
            (this.props.readOnly && qualification.selected)
          ) {
            otherSection.push(this.createLine(qualification));
          }
          break;

        case QualificationTypeEnum.TRADE:
          if (
            !this.props.readOnly ||
            (this.props.readOnly && qualification.selected)
          ) {
            if (
              qualification.trade !== null &&
              qualification.trade !== undefined
            ) {
              if (tradeSection === null) {
                tradeSection = {};
              }
              let tradeContainer = tradeSection[qualification.trade.value];
              if (tradeContainer === undefined) {
                tradeContainer = {
                  label: qualification.trade.label,
                  lines: [],
                };
              }
              tradeContainer.lines.push(this.createLine(qualification));
              tradeSection[qualification.trade.value] = tradeContainer;
            }
          }

          break;

        default:
      }
    });

    return (
      <div className="qualifications-viewer">
        {generalSection.length > 0 &&
          QualificationsViewer.createSection(
            QualificationTypeEnum.GENERAL.label,
            generalSection
          )}
        {tradeSection !== null &&
          Object.keys(tradeSection)
            .sort()
            .map((key, index) => {
              return QualificationsViewer.createSection(
                tradeSection[key].label,
                tradeSection[key].lines,
                index
              );
            })}
        {otherSection.length > 0 &&
          QualificationsViewer.createSection(
            QualificationTypeEnum.OTHER.label,
            otherSection
          )}
        {generalSection.length === 0 &&
          tradeSection === null &&
          otherSection.length === 0 && (
            <div className="body-regular text-center" style={{ width: '100%' }}>
              No qualifications
            </div>
          )}
      </div>
    );
  }

  handleOptionChange = (qualificationId, option) => {
    if (this.props.onOptionSelected !== undefined) {
      this.props.onOptionSelected(qualificationId, option);
    }
  };

  handleQualificationChange = (qualificationId) => {
    if (this.props.onQualificationSelected !== undefined) {
      this.props.onQualificationSelected(qualificationId);
    }
  };

  createLine(qualification) {
    return (
      <div key={qualification.id} className="line">
        <CheckBox
          checked={qualification.selected}
          readOnly={this.props.readOnly}
          onChange={this.handleQualificationChange.bind(this, qualification.id)}
        />
        <div className="qualification-label">{qualification.label}</div>
        {qualification.options !== undefined &&
          qualification.options.length > 0 &&
          qualification.selected && (
            <React.Fragment>
              {this.props.readOnly ? (
                <span>
                  {qualification.options
                    .filter((option) => option.selected)
                    .reduce((accumulator, currentOption) => {
                      return currentOption.label;
                    }, null)}
                </span>
              ) : (
                <Dropdown
                  className="options-dropdown"
                  options={qualification.options.map((option) => {
                    return { value: option.id, label: option.label };
                  })}
                  value={qualification.options
                    .filter((option) => option.selected)
                    .reduce((accumulator, currentOption) => {
                      return currentOption.id;
                    }, null)}
                  placeholder="Select option"
                  onChange={this.handleOptionChange.bind(
                    this,
                    qualification.id
                  )}
                />
              )}
            </React.Fragment>
          )}
      </div>
    );
  }

  static createSection(label, section, key) {
    return (
      <div className="section" key={key}>
        <div className="body-regular">{label}</div>
        {section}
      </div>
    );
  }
}

export default QualificationsViewer;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/qualifications/QualificationsViewer.js